import { httpClient } from '@/configs/axios.config'
import type {
  DashboardStats,
  SyncHistoryQuery,
  QueueJobDetail,
  SyncRunDetail,
  SyncRunListResponse,
  SyncStatusResponse,
} from '@/features/chronograph-dashboard/types'

const BASE = '/admin/chronograph'

export async function getDashboardStats(
  periodDays = 30
): Promise<DashboardStats> {
  const response = await httpClient.get<DashboardStats>(`${BASE}/dashboard`, {
    params: { periodDays },
  })
  return response.data
}

export async function getSyncStatus(): Promise<SyncStatusResponse> {
  const response = await httpClient.get<SyncStatusResponse>(`${BASE}/status`)
  return response.data
}

export async function getSyncJobStatus(jobId: string): Promise<QueueJobDetail> {
  const response = await httpClient.get<QueueJobDetail>(`${BASE}/jobs/${jobId}`)
  return response.data
}

export async function getSyncHistory(
  query: SyncHistoryQuery = {}
): Promise<SyncRunListResponse> {
  const response = await httpClient.get<SyncRunListResponse>(
    `${BASE}/history`,
    { params: query }
  )
  return response.data
}

export async function getSyncRunDetail(id: string): Promise<SyncRunDetail> {
  const response = await httpClient.get<SyncRunDetail>(`${BASE}/runs/${id}`)
  return response.data
}

export async function triggerSyncCompanies(): Promise<{
  jobId: string
  message: string
}> {
  const response = await httpClient.post<{ jobId: string; message: string }>(
    `${BASE}/sync/companies`,
    undefined,
    { params: { async: true } }
  )
  return response.data
}

export async function triggerSyncInvestments(): Promise<{
  jobId: string
  message: string
}> {
  const response = await httpClient.post<{ jobId: string; message: string }>(
    `${BASE}/sync/investments`,
    undefined,
    { params: { async: true } }
  )
  return response.data
}

export async function triggerSyncMetrics(body: {
  startDate: string
  endDate: string
}): Promise<{ jobId: string; message: string }> {
  const response = await httpClient.post<{ jobId: string; message: string }>(
    `${BASE}/sync/metrics`,
    body,
    { params: { async: true } }
  )
  return response.data
}

export async function triggerSyncFull(): Promise<{
  jobId: string
  message: string
}> {
  const response = await httpClient.post<{ jobId: string; message: string }>(
    `${BASE}/sync/full`,
    undefined,
    { params: { async: true } }
  )
  return response.data
}

export async function triggerBackfill(body: {
  startYear: number
  endYear: number
}): Promise<{ jobId: string; message: string }> {
  const response = await httpClient.post<{ jobId: string; message: string }>(
    `${BASE}/backfill`,
    body,
    { params: { async: true } }
  )
  return response.data
}
